import React, { FC } from 'react';

import { ROUTER_PATHS } from '@constants/router';
import MainLogo from 'images/ifood-logo-white.svg';
import { Notification } from 'modules/Notification';

import { LEFT_HEADER_PORTAL_ID, RIGHT_HEADER_PORTAL_ID } from '../../constants';
import { Container, Content, LeftContent, LogoLink, NavLinkList, RightContent } from './styles';

const Header: FC = () => {
  return (
    <Container>
      <Content>
        <LeftContent id={LEFT_HEADER_PORTAL_ID} />

        <LogoLink dataTestId="link-to-home" href={ROUTER_PATHS.HOME}>
          <img alt="logo" src={MainLogo} />
        </LogoLink>

        <RightContent id={RIGHT_HEADER_PORTAL_ID} />
      </Content>

      <NavLinkList mobile />
      <Notification />
    </Container>
  );
};

export default Header;
